<div class="db-settings__default-mode">

  <div class="db-settings__default-mode-header">
    <h2 class="mb4">Image optimization modes <i class="db-icon db-icon-info-lined ml5" [dsTooltip]="'text_ioOptimizerTitleTooltip' | dbText" dsTooltipAlign="left" dsTooltipPosition="bottom"></i></h2>
    <p class="mb20">Switch between optimization modes to find the setting that works best for your website.</p>
  </div>

  <div>
    <div class="db-settings__options">
      <div class="db-settings__default-mode-options"
           *ngFor="let option of settingsOptions; let i = index"
           [ngClass]="{'active': option?.id === ioMode, 'ds-lazy-load': !!ioModeLoading}" (click)="
           option?.id !==
           ioMode && selectMode(option?.id)">

        <div class="db-settings__default-mode-options-select">

          <div class="circle-container" [ngClass]="{'selected': option?.id === ioMode}">
            <div class="outer-circle">
              <div class="inner-circle"></div>
            </div>
          </div>
          <div class="db-settings__default-mode-info">
            <p class="db-title">
              <b [innerHTML]="option.title | dbText"></b>
              <i *ngIf="option?.id === 'lossy'" class="db-icon db-icon-ds-info-bg yellow ml5" [dsTooltip]="'text_ioOptimizerExtremeTooltip' | dbText" dsTooltipAlign="right" dsTooltipPosition="bottom"></i>
            </p>
            <p class="mt4" [innerHTML]="option.desc | dbText"></p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
